export enum EPaymentMethods {
  Cash = "Cash",
  Card = "Card",
}

export const PaymentMethodsConfig = {
  [EPaymentMethods.Card]: "Карта",
  [EPaymentMethods.Cash]: "Готівка",
}
